// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.enedis-frame-view { display:none;\n}\n.component-root {\n\theight:100vh;\n}\n", ""]);
// Exports
module.exports = exports;
